export class AccountingModelKey {
  static readonly ACCOUNTING_RECORD = 'accounting/model/accounting-record';
  static readonly ACCOUNTING_RECORD_TYPE = 'accounting/model/accounting-record-type';
  static readonly ACCOUNTING_LOGO_TYPE = 'accounting/model/accounting-logo-type';
}
